import { render, staticRenderFns } from "./TwoFAWindow.vue?vue&type=template&id=28030aa9&scoped=true&"
import script from "./TwoFAWindow.vue?vue&type=script&lang=js&"
export * from "./TwoFAWindow.vue?vue&type=script&lang=js&"
import style0 from "./TwoFAWindow.vue?vue&type=style&index=0&id=28030aa9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28030aa9",
  null
  
)

export default component.exports